import React from "react";
import { Navigate, useParams } from "react-router-dom";

/**
 * Legacy redirect — the standalone /c/:username/community page was merged
 * into the streamer's home page (/c/:username). Any old links now bounce
 * over to the new single-page community experience.
 */
export default function CommunityRedirect() {
  const { username } = useParams();
  return <Navigate to={`/c/${username}`} replace />;
}
